import React from "react";
import { Button } from "src/components/ui/button";
import { CalendarIcon } from "lucide-react";
import { cn } from "src/lib/utils";
import { Calendar } from "src/components/ui/calandar";
import { Popover, PopoverContent, PopoverTrigger } from "src/components/ui/popover";
import { format } from "date-fns";

interface DateRangeSelectorProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
  onDateRangeChange: (start: Date | undefined, end: Date | undefined) => void;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({ startDate, endDate, onDateRangeChange }) => {
  const renderDateRangeText = () => {
    if (!startDate) {
      return <span>Pick a date range</span>;
    }

    if (!endDate) {
      return format(startDate, "LLL dd, y");
    }

    return (
      <>
        {format(startDate, "LLL dd, y")} - {format(endDate, "LLL dd, y")}
      </>
    );
  };

  const handleCalendarClick = (event: React.MouseEvent) => {
    // Prevent calendar interactions from bubbling up to parent click handlers
    event.stopPropagation();
  };

  return (
    <div className="flex items-center gap-2">
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className={cn("w-[300px] justify-start text-left font-normal", !startDate && "text-muted-foreground")}>
            <CalendarIcon className="mr-2 h-4 w-4" />
            {renderDateRangeText()}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[400px] p-0 z-[99999]" align="start" onClick={handleCalendarClick}>
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={startDate}
            selected={{ from: startDate, to: endDate }}
            onSelect={(range) => {
              onDateRangeChange(range?.from, range?.to);
            }}
            classNames={{
              root: "w-full",
            }}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DateRangeSelector;
